import styled from "styled-components";

export const ComingSoonItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0 auto;
  align-items: center;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${(props) => props.theme.colors.mainBg};
  padding: 16px;
`;

export const ComingSoonTit = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  h4 {
    font-size: 1.6rem;
    font-weight: 800;
  }

  span {
    font-size: 1.4rem;
    color: ${(props) => props.theme.colors.black38};
  }
`;